import { render } from "./score.vue?vue&type=template&id=6947691a"
import script from "./score.vue?vue&type=script&lang=js"
export * from "./score.vue?vue&type=script&lang=js"

import exportComponent from "/Users/baptiste/P_8678-Amis-des-musees-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__